import React, { Component } from 'react';
import SwipeListener from '../../lib/swipe-listener';

const minXSwipe = 50;

class SwipeNextPrev extends Component {
  componentDidMount() {
    this.element = this.props.element ? this.props.element : window;
    this.listener = SwipeListener(this.element, {
      // minHorizontal: 50,
      // minVertical: 50,
      // deltaHorizontal: 50,
      lockAxis: true,
    });
    // element.addEventListener('swipe', this.handleSwipe);
    this.element.addEventListener('swiping', this.handleSwipe);
    this.element.addEventListener('swiperelease', this.handleSwipeEnd);

    this.reset();
  }
  reset() {
    this.start = 0;
    this.isSwiping = false;
    this.fired = false;
  }
  componentWillUnmount() {
    this.element.removeEventListener('swiping', this.handleSwipe);
    this.element.removeEventListener('swiperelease', this.handleSwipeEnd);
    this.listener.off();
  }
  handleSwipeEnd = () => {
    this.reset();
  };
  handleSwipe = e => {
    const swipeXCoord = e.detail.x[1];
    if (!this.isSwiping) {
      // start
      this.isSwiping = true;
      this.start = swipeXCoord;
    } else {
      const diff = swipeXCoord - this.start;
      if (Math.abs(diff) > minXSwipe && !this.fired) {
        this.fired = true;
        if (diff > 0) {
          this.props.prev();
        } else {
          this.props.next();
        }
      }
    }
  };
  render() {
    return null;
  }
}

export default SwipeNextPrev;



// WEBPACK FOOTER //
// ./src/components/ui/SwipeNextPrev.js